// The one super admin account. The backend checks the same address (and that it is verified);
// this copy only decides whether to show the Admin link and page.
export const SUPER_ADMIN_EMAIL = 'kyle@odikai.bet';

export function isSuperAdminEmail(user) {
  return Boolean(user && typeof user.email === 'string' && user.email.toLowerCase() === SUPER_ADMIN_EMAIL);
}
